import * as z from "zod";

/** An image an imported macro still links to on the source helpdesk because copying it failed. */
export const macroImageFailure = z.object({
  macroId: z.string(),
  macroName: z.string(),
  imageHost: z.string(),
  reason: z.string(),
});

export type MacroImageFailure = z.infer<typeof macroImageFailure>;

export const importMacrosResult = z.object({
  importedCount: z.number(),
  skippedCount: z.number(),
  imageFailures: z.array(macroImageFailure).readonly(),
});

export type ImportMacrosResult = z.infer<typeof importMacrosResult>;
